import React from "react";
const BotsSvg = ({ color = "white", className, ...props }) => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M28.7645 7.59713H21.8085V5.34686C22.7221 4.99558 23.3736 4.11112 23.3736 3.07572C23.3736 1.73356 22.2811 0.641113 20.9389 0.641113C19.5968 0.641113 18.5043 1.73356 18.5043 3.07572C18.5043 4.11147 19.1558 4.99593 20.0694 5.34686V7.59713H13.1134C10.3328 7.59713 8.07031 9.85958 8.07031 12.6402V21.3353C8.07031 24.1159 10.3328 26.3784 13.1134 26.3784H28.7645C31.5451 26.3784 33.8076 24.1159 33.8076 21.3353V12.6402C33.8076 9.85958 31.5451 7.59713 28.7645 7.59713ZM20.9389 2.38012C21.3229 2.38012 21.6346 2.6921 21.6346 3.07572C21.6346 3.45934 21.3229 3.77132 20.9389 3.77132C20.5553 3.77132 20.2433 3.45934 20.2433 3.07572C20.2433 2.6921 20.5553 2.38012 20.9389 2.38012ZM32.0686 21.3353C32.0686 23.1571 30.5863 24.6394 28.7645 24.6394H13.1134C11.2916 24.6394 9.80932 23.1571 9.80932 21.3353V12.6402C9.80932 10.8185 11.2916 9.33614 13.1134 9.33614H28.7645C30.5863 9.33614 32.0686 10.8185 32.0686 12.6402V21.3353Z"
        fill={color}
      />
      <path
        d="M14.8524 17.3357C16.0049 17.3357 16.9392 16.4014 16.9392 15.2489C16.9392 14.0964 16.0049 13.1621 14.8524 13.1621C13.6999 13.1621 12.7656 14.0964 12.7656 15.2489C12.7656 16.4014 13.6999 17.3357 14.8524 17.3357Z"
        fill={color}
      />
      <path
        d="M27.0253 17.3357C28.1778 17.3357 29.1121 16.4014 29.1121 15.2489C29.1121 14.0964 28.1778 13.1621 27.0253 13.1621C25.8728 13.1621 24.9385 14.0964 24.9385 15.2489C24.9385 16.4014 25.8728 17.3357 27.0253 17.3357Z"
        fill={color}
      />
      <path
        d="M28.2428 30.552C28.7231 30.552 29.1123 30.1628 29.1123 29.6825C29.1123 29.2022 28.7231 28.813 28.2428 28.813H13.6351C13.1548 28.813 12.7656 29.2022 12.7656 29.6825C12.7656 30.1628 13.1548 30.552 13.6351 30.552H28.2428Z"
        fill={color}
      />
      <path
        d="M24.4168 20.9873H17.4608C16.9805 20.9873 16.5913 21.3765 16.5913 21.8568C16.5913 22.3371 16.9805 22.7263 17.4608 22.7263H24.4168C24.8971 22.7263 25.2863 22.3371 25.2863 21.8568C25.2863 21.3765 24.8971 20.9873 24.4168 20.9873Z"
        fill={color}
      />
    </svg>
  );
};

export default BotsSvg;
